import { render } from "./table-powertrain.svg?vue&type=template&id=0c9f1c36?inline"
const script = {}
script.render = render

export default script